<app-dashboard-switcher *ngIf="false && CanSwitchVariant()" (CurrentVariant)="SwitchVariant($event)"></app-dashboard-switcher>

<app-html-widget blocktitle="Dashboard Header"></app-html-widget>

<app-landing-anonymous *ngIf="GetLandingPageVariant() == 'anonymous'"></app-landing-anonymous>
<app-landing-nonmember *ngIf="GetLandingPageVariant() == 'nonmember'"></app-landing-nonmember>
<app-landing-cpp *ngIf="GetLandingPageVariant() == 'cpp'"></app-landing-cpp>
<app-landing-student *ngIf="GetLandingPageVariant() == 'student'"></app-landing-student>
